import { GameState, PlayerColor } from './types';
import { isSafeStep } from './board';
import { isInDanger, wouldCapture } from './game';

// ── Оценка конкретного хода ───────────────────────────────────────────────
function scoreMove(
  state: GameState,
  player: PlayerColor,
  pieceId: number,
  dice: number
): number {
  const piece = state.pieces.find(p => p.player === player && p.id === pieceId)!;
  const toSteps = piece.steps === -1 ? 0 : piece.steps + dice;
  let score = 0;

  // 1. Базовый прогресс
  score += toSteps;

  // 2. Захват противника (+1000)
  if (wouldCapture(state, player, toSteps)) score += 1000;

  // 3. Финиш фишки (+800)
  if (toSteps === 57) score += 800;

  // 4. Выход из дома (+500)
  if (piece.steps === -1) score += 500;

  // 5. Безопасная клетка (+300)
  if (isSafeStep(player, toSteps)) score += 300;

  // 6. Опасная целевая клетка (-200)
  if (isInDanger(state, player, toSteps)) score -= 200;

  // 7. Лишний выход: если уже 3+ активных фишки — не спешим выводить (-100)
  const activePieces = state.pieces.filter(
    p => p.player === player && p.steps >= 0 && p.steps < 57
  );
  if (piece.steps === -1 && activePieces.length >= 3) score -= 100;

  return score;
}

// ── Выбор лучшего хода ────────────────────────────────────────────────────
export function pickAiMove(state: GameState): number {
  const player  = state.currentPlayer;
  const moves   = state.selectablePieces;
  const dice    = state.dice.value;

  if (moves.length === 0) return -1;
  if (moves.length === 1) return moves[0];

  let bestId    = moves[0];
  let bestScore = -Infinity;

  for (const id of moves) {
    const s = scoreMove(state, player, id, dice);
    if (s > bestScore) { bestScore = s; bestId = id; }
  }

  return bestId;
}
